import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Text } from 'components/Text';
import { BorderRadius } from './utils';

interface Props {
  borderRadius: BorderRadius;
  dataTestId?: string;
  title: string;
  subtitle?: string;
  rightContent?: ReactNode;
  onClick?: () => void;
}

export const HorizontalCard = ({
  title,
  subtitle,
  rightContent,
  borderRadius,
  dataTestId = 'horizontal-card',
  onClick
}: Props) => (
  <Card
    sx={{ minWidth: 275, ...borderRadius, cursor: 'pointer' }}
    onClick={onClick}
    data-testid={dataTestId}
  >
    <CardContent>
      <Box
        sx={{
          display: 'flex',
          justifyContent: rightContent ? 'space-between' : 'left',
          bgcolor: 'background.paper'
        }}
      >
        <Box>
          <Text variant="subtitle1" component="div" sx={{ mb: 1 }}>
            {title}
          </Text>
          <Text variant="body2">{subtitle}</Text>
        </Box>
        <Box>{rightContent}</Box>
      </Box>
    </CardContent>
  </Card>
);
